import "rxjs/add/observable/throw";
import "rxjs/add/operator/timeoutWith";
import "rxjs/add/operator/toPromise";

import { Injectable } from "@angular/core";
import * as _ from "lodash";
import * as moment from "moment";
import { Observable } from "rxjs/Observable";

import { environment } from "../../environments/environment";
import { DepositSearch } from "../models/depositSearch.model";
import { DepositSearchResult } from "../models/depositSearchResult.model";
import { ILimitedResult } from "../models/limitedResult";
import { PaymentFile } from "../models/paymentFile.model";
import { ZeroDollarCheckDeposit } from "../models/zerodollarcheckdeposit.model";
import { BaseService } from "./api-base.service";
import { ReconApiService } from "./recon-api.service";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable()
export class DepositService {
  private readonly Timeout: number = 30000;
  private readonly basePath: string = "PaymentFiles";

  constructor(
    private http: HttpClient,
    private apiBase: BaseService,
    private reconApiService: ReconApiService
  ) {}

  public async getUnpostedPaymentFiles<T>(
    clientId: string,
    limit: number,
    offset: number,
    sort: string = "",
    sortOrder?: number
  ): Promise<ILimitedResult<T>> {
    const baseUrl = `${environment.reconApiRoot.url}/client/${clientId}/${this.basePath}/UnpostedPaymentFiles`;
    let params = new HttpParams()
      .set("limit", limit.toString())
      .set("offset", offset.toString());

    if (sort) {
      params = params
        .set("sort", sort)
        .set("sortOrder", sortOrder === 1 ? "asc" : "desc");
    }

    const response = await this.http
      .get<ILimitedResult<T>>(baseUrl, {
        headers: this.apiBase.getHeaders(),
        params: params,
      })
      .timeoutWith(
        this.Timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${
            error && error.status ? error.status.toString() : "unknown"
          }`
        );
        const fullUrl = `${baseUrl}?${params.toString()}`;
        this.reconApiService.logToElasticSearchFromUI(error, fullUrl);
        return null;
      });

    if (!response) {
      return null;
    }

    this.convertDates(response.Items, "MM/DD/YYYY");

    return response;
  }

  public async postToPaymentFileQueue(
    clientId: string,
    data: PaymentFile[]
  ): Promise<any> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/${this.basePath}/QueuePaymentFilesForDepositAssociation`;
    const response = await this.http
      .post<any>(url, data, { headers: this.apiBase.getHeaders() })
      .timeoutWith(
        this.Timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`
        );
        this.reconApiService.logToElasticSearchFromUI(error, url);
        return null;
      });

    if (!response) {
      return null;
    }

    return response;
  }

  public async searchDeposits<T>(
    clientId: string,
    data: DepositSearch,
    limit: number,
    offset: number,
    sort: string,
    sortOrder: number
  ): Promise<ILimitedResult<T>> {
    const baseUrl = `${environment.reconApiRoot.url}/client/${clientId}/Deposit/Checks`;
    let params = new HttpParams()
      .set("limit", limit.toString())
      .set("offset", offset.toString());

    if (sort !== undefined && sort !== null && sort !== "") {
      params = params.set("sort", sort);

      if (sortOrder !== undefined && sortOrder !== null) {
        const sortOrderAscDesc = sortOrder === 1 ? "asc" : "desc";
        params = params.set("sortorder", sortOrderAscDesc);
      }
    }
    const response = await this.http
      .post<ILimitedResult<T>>(baseUrl, data, {
        headers: this.apiBase.getHeaders(),
        params: params,
      })
      .timeoutWith(
        this.Timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${
            error && error.status ? error.status.toString() : "unknown"
          }`
        );
        const fullUrl = `${baseUrl}?${params.toString()}`;
        this.reconApiService.logToElasticSearchFromUI(error, fullUrl);

      });

    return response;
  }

  public async createZeroDollarCheck(
    clientId: string,
    zeroDollarCheckDeposit: ZeroDollarCheckDeposit
  ): Promise<DepositSearchResult> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/Deposit/ZeroDollarChecks/`;
    let response = await this.http
      .post<DepositSearchResult>(url, zeroDollarCheckDeposit, {
        headers: this.apiBase.getHeaders(),
      })
      .timeoutWith(
        this.Timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} with status: ${error.status.toString()}`
        );
      });
    return response;
  }

  private convertDates<T>(collection: any[], format: string): void {
    _.forEach(collection, (o) => {
      o.Check_CheckDate = moment(o.Check_CheckDate).format(format).toString();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/deposit-api.service.ts